export class TokenModel {
  id: number;
  tokenName: string;
  accessToken: string;
  expires: Date;
}
